export const scheduleDocuments = {
  primary: 'https://www.batestkd.com/_files/ugd/37c34b_801a7cd33b0645a58a494ade4e14671b.pdf',
  alternate: 'https://www.batestkd.com/_files/ugd/37c34b_3e14ea4be4b74e71933a4fc67bf4941b.pdf',
  publishedYear: 2025,
} as const;

// These are historical source listings. The original page does not give a year.
export const eventArchive = [
  {
    month: 'October',
    entries: [
      { date: 'October 3', title: 'Disneyland tournament' },
      { date: 'October 10', title: 'Birthday party rental', detail: 'Bates available to rent: 2 hours $300 or 3 hours $400.' },
      { date: 'October 15', title: 'Popcorn forms due' },
      { date: 'October 17', title: 'Event rental', detail: 'Bates available to rent: 2 hours $300 or 3 hours $400.' },
      { date: 'October 23–25', title: 'G1 tournament', detail: 'Daytona Beach, FL · Black belts only.' },
      { date: 'October 30', title: 'Juegos Iternacionales Baja Tournament' },
    ],
  },
  {
    month: 'November',
    entries: [
      { date: 'November 7', title: 'Facility rental', detail: 'Bates available to rent: 2 hours $300 or 3 hours $400.' },
      { date: 'November 13', title: 'Popcorn forms due' },
      { date: 'November 14', title: 'Rumble at Bates!' },
      { date: 'November 21', title: 'Event rental', detail: 'Bates available to rent: 2 hours $300 or 3 hours $400.' },
      { date: 'November 25–27', title: 'School closed' },
      { date: 'November 25–December 2', title: 'Taipei City Cup', detail: 'Taipei, Taiwan.' },
    ],
  },
  {
    month: 'December',
    entries: [
      { date: 'December 5', title: 'Event rental', detail: 'Bates available to rent: 2 hours $300 or 3 hours $400.' },
      { date: 'December 12', title: 'Belt testing' },
      { date: 'December 15', title: 'Popcorn forms due' },
      { date: 'December 19', title: 'Event rental', detail: 'Bates available to rent: 2 hours $300 or 3 hours $400.' },
      { date: 'December 21–January 2', title: 'Villas Holiday Training', detail: 'Los Angeles, CA.' },
      { date: 'December 23–January 1', title: 'School closed' },
    ],
  },
  {
    month: 'January–March',
    entries: [
      { date: 'January 17', title: 'Pan Am Team Trials', detail: 'Memphis, TN.' },
      { date: 'January 30', title: 'USA Taekwondo Team Trial' },
      { date: 'February 13', title: 'USAT Arizona tournament' },
      { date: 'March 2–8', title: 'Canada Open', detail: 'Vancouver.' },
      { date: 'March 18–21', title: 'US Open', detail: 'Las Vegas.' },
      { date: 'March 26–28', title: 'CUTA', detail: 'Fresno, CA.' },
    ],
  },
  {
    month: 'May–July',
    entries: [
      { date: 'May 1', title: 'ITF', detail: 'Los Angeles, CA.' },
      { date: 'June 18–20', title: 'USAT Regional', detail: 'Albuquerque, NM.' },
      { date: 'July 7–11', title: 'USAT Nationals', detail: 'Fort Worth, TX.' },
    ],
  },
] as const;

export const eventPhotos = [
  {
    src: 'https://static.wixstatic.com/media/37c34b_1dd830e0ae214eab91429dacaa4b2e30~mv2.jpg',
    alt: 'Taekwondo tournament rings and spectators inside a gymnasium',
    width: 2048,
    height: 1536,
  },
  {
    src: 'https://static.wixstatic.com/media/37c34b_cb2e8b28f06d469b8c40175ebed37ac4~mv2.jpg',
    alt: 'A large indoor arena arranged for a Taekwondo tournament',
    width: 1440,
    height: 1080,
  },
  {
    src: 'https://static.wixstatic.com/media/37c34b_c8b69cf469f847d7bd8232502b4cda87~mv2.jpg',
    alt: 'Competitors and spectators gathered around tournament mats in a ballroom',
    width: 1316,
    height: 640,
  },
  {
    src: 'https://static.wixstatic.com/media/37c34b_0443d885bd0a4e62a6b6efbae7a1803f~mv2.jpg',
    alt: 'Taekwondo competition beneath a 2019 Texas Cup banner',
    width: 2048,
    height: 1536,
  },
  {
    src: 'https://static.wixstatic.com/media/37c34b_5ec081aca0374450ba393ff1a963c447~mv2.jpg',
    alt: 'Tournament mats and spectators at the Grand Phoenix Open',
    width: 2048,
    height: 1536,
  },
] as const;

export const merchandise = {
  image: 'https://static.wixstatic.com/media/37c34b_2a4b4375247d4a8699d08e2beaca2570~mv2.png',
  orderingUrl: 'https://www.batestkd.com/merch',
  colors: ['Black', 'Red'],
  fabrics: ['Dry-fit', 'Cotton'],
} as const;
